export default __webpack_public_path__ + "static/media/anand.fa4a2d9f.txt";